import React, { useState, useEffect } from "react";
import { Card, Badge } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
  LabelList,
} from "recharts";
import axios from "axios";

const SalesChart = () => {
  const [weekData, setWeekData] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get("./dati_dashboard.json")
        .then((res) => {
          const weekOrdersData = res.data.AR.settimana;
          const sortedWeekData = weekOrdersData.sort(
            (a, b) => a.ordine_giorno - b.ordine_giorno
          );
          setWeekData(sortedWeekData);
        })
        .catch((err) => console.error(err));
    };
    fetchData();
  }, []);

  const today = new Date().getDay();
  // Correzione domenica (0 diventa 7 per allinearsi all'ordine ISO)
  const currentDayIndex = today === 0 ? 7 : today;

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  // Label personalizzata per il Trend (%)
  const renderTrendLabel = (props) => {
    const { x, y, width, index } = props;
    const dataItem = weekData[index];
    if (!dataItem || index >= currentDayIndex) return null;

    const valore = parseFloat(dataItem.valore_ordinato);
    const media = parseFloat(dataItem.media_valore);
    
    if (media === 0) return null;
    
    const trend = ((valore - media) / media) * 100;
    const color = trend >= 0 ? "#28a745" : "#dc3545";

    return (
      <text
        x={x + width / 2}
        y={y - 12}
        fill={color}
        textAnchor="middle"
        style={{ fontSize: "10px", fontWeight: "800" }}
      >
        {trend >= 0 ? "▲" : "▼"} {Math.abs(trend).toFixed(1)}%
      </text>
    );
  };

  const maxYValue = Math.max(...weekData.map((d) => Math.max(d.valore_ordinato, d.media_valore))) * 1.15;

  return (
    <Card className="card ombra card-week bg-dark card-home hover-effect border-0" style={{ borderRadius: '15px', padding: '1rem' }}>
      <div className="d-flex justify-content-between align-items-center mb-4 px-3">
        <div>
          <h6 className="text-title2 fw-bold mb-0" style={{ letterSpacing: '1px' }}>
            PERFORMANCE SETTIMANALE
          </h6>
          <small className="text-light" style={{ fontSize: '0.65rem' }}>Confronto valore ordinato vs media 6 mesi</small>
        </div>
        <Badge pill style={{ fontSize: '0.6rem', padding: '5px 10px', backgroundColor: 'rgba(241,111,36,1)' }}>WEEKLY</Badge>
      </div>

      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={weekData}
            margin={{ top: 30, right: 10, left: 0, bottom: 0 }}
            barGap={8}
          >
            <XAxis
              dataKey="it_nome_giorno"
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#6c757d', fontSize: '11px', fontWeight: '600' }}
              tickFormatter={(str) => str.substring(0, 3).toUpperCase()}
            />
            <YAxis hide domain={[0, maxYValue]} />
            
            <Tooltip
              cursor={{ fill: 'rgba(255, 255, 255, 0.03)' }}
              contentStyle={{
                borderRadius: '10px',
                border: 'none',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                fontSize: '12px'
              }}
              formatter={(value) => [formatToEuro(value), ""]}
            />
            
            <Legend 
              verticalAlign="bottom" 
              iconType="circle"
              wrapperStyle={{ paddingTop: '20px', fontSize: '12px', fontWeight: '600', color: 'white' }}
            />
            
            {/* BARRA VALORE ATTUALE */}
            <Bar
              dataKey="valore_ordinato"
              name="Ordinato"
              radius={[6, 6, 0, 0]}
              barSize={40}
            >
              <LabelList content={renderTrendLabel} />
              {weekData.map((entry, index) => (
                <Cell 
                  key={`cell-v-${index}`} 
                  fill="rgba(241,111,36,1)" 
                  fillOpacity={index < currentDayIndex ? 1 : 0.2} 
                />
              ))}
            </Bar>

            {/* BARRA MEDIA */}
            <Bar
              dataKey="media_valore"
              name="Media (6m)"
              radius={[6, 6, 0, 0]}
              barSize={40}
            >
              {weekData.map((entry, index) => (
                <Cell 
                  key={`cell-m-${index}`} 
                  fill="#cccccc" 
                  fillOpacity={index < currentDayIndex ? 0.8 : 0.2} 
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default SalesChart;